import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Breadcrumb } from "antd";
import styles from "./../App.module.scss";
export function Breadcrumbs() {
  const [breadcrumbs, setBreadcrumbs] = useState<string[]>([]);
  const [pathParts, setPathParts] = useState<string[]>([]);
  const location = useLocation();

  useEffect(() => {
    const pathParts = decodeURI(location.pathname)
      .split("/")
      .filter((part) => part.trim() !== "");
    setPathParts(pathParts);
    if (pathParts[0] == "services" && pathParts.length) {
      const nameArray = pathParts.map((v) => getRoutName(v));

      setBreadcrumbs(nameArray);
    } else setBreadcrumbs([]);
  }, [location]);
  const navigate = useNavigate();
  const getRoutName = (item: string) => {
    switch (item) {
      case "services":
        return "Services";
      case "backend":
        return "Back-end development";
      case "frontend":
        return "Front-end development";
      case "web-applications":
        return "Web Sites & Application";
      case "design":
        return "Design UI/UX";
      default:
        return "";
    }
  };
  const goTo = (index: number) => {
    navigate({
      pathname: `/${pathParts.slice(0, index + 1).join("/")}`,
    });
  };

  return (
    <div>
      {breadcrumbs.length > 1 && (
        <Breadcrumb className={styles.breadcrumb}>
          {breadcrumbs.map((item, index) => (
            <Breadcrumb.Item key={index}>
              <div onClick={() => goTo(index)}>{item}</div>
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      )}
    </div>
  );
}
